/**
 * Personalisation tracking for shows
 * Tracks viewed shows in cookies and uses them for personalised content
 */

(function() {
    'use strict';

    const COOKIE_NAME = 'farlo_viewed_shows';
    const MAX_TRACKED_SHOWS = 20; // Maximum number of shows to track
    const COOKIE_EXPIRY_DAYS = 30;

    /**
     * Get cookie value by name
     */
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
        return null;
    }

    /**
     * Set cookie with expiry
     */
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = `expires=${date.toUTCString()}`;
        document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
    }

    /**
     * Get array of viewed show IDs from cookie
     */
    function getViewedShows() {
        const cookieValue = getCookie(COOKIE_NAME);
        if (!cookieValue) {
            return [];
        }
        try {
            return JSON.parse(decodeURIComponent(cookieValue));
        } catch (e) {
            console.error('Error parsing viewed shows cookie:', e);
            return [];
        }
    }
    function clearViewedShows() {
        setCookie(COOKIE_NAME, [], -1);
    }

    /**
     * Track a show view
     */
    function trackShowView(postId) {
        if (!postId || isNaN(postId)) {
            return;
        }

        postId = parseInt(postId, 10);
        let viewedShows = getViewedShows();

        // Remove the post ID if it already exists (we'll add it to the front)
        viewedShows = viewedShows.filter(id => id !== postId);

        // Add the new post ID to the front of the array
        viewedShows.unshift(postId);

        // Limit the array to MAX_TRACKED_SHOWS
        viewedShows = viewedShows.slice(0, MAX_TRACKED_SHOWS);

        // Save to cookie
        const cookieValue = encodeURIComponent(JSON.stringify(viewedShows));
        setCookie(COOKIE_NAME, cookieValue, COOKIE_EXPIRY_DAYS);
    }

    /**
     * Initialise tracking on single show pages
     */
    function init() {
        // Check if we're on a single show page and have the post ID
        if (typeof farloPersonalisation !== 'undefined' && farloPersonalisation.postId) {
            trackShowView(farloPersonalisation.postId);
        }
    }

    // Initialise when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Expose utility function for debugging
    window.farloPersonalisationUtils = {
        getViewedShows: getViewedShows,
        trackShowView: trackShowView,
        clearViewedShows: clearViewedShows,
    };

})();
